/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProgramView_currentMetaData = {
    readonly startDate: string;
    readonly endDate: string;
    readonly " $refType": "ProgramView_currentMetaData";
};
export type ProgramView_currentMetaData$data = ProgramView_currentMetaData;
export type ProgramView_currentMetaData$key = {
    readonly " $data"?: ProgramView_currentMetaData$data;
    readonly " $fragmentRefs": FragmentRefs<"ProgramView_currentMetaData">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProgramView_currentMetaData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    }
  ],
  "type": "MetaData",
  "abstractKey": null
};
(node as any).hash = '83fbb4f77c093ffe678d534969cd51b5';
export default node;
